// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite_row {
  height: 500px;
}

.one2one_section {
  border: 1px solid lightgray;
  border-radius: 14px;
  background-color: white;
}

.group_section {
  border: 1px solid lightgray;
  border-radius: 10px;
  background-color: white;
}

.one2one_section img,
.group_section img {
  height: 220px;
  width: auto;
}

.invite_container {
  height: auto;
  margin-top: 50px;
}

.invite_row button {
  background-color: #548dff !important;
  color: white;
}

.invite_row button:hover {
  background-color: rgb(29, 101, 244) !important;
  color: white;
}

._3uApM {
  justify-content: end !important;
}

._3uApM a {
  text-decoration: none !important;
  margin-left: 20px;
  padding-left: 40px;
  padding-right: 40px;
}

._hsN1w {
  background-color: #548dff !important;
}

._hsN1w:hover {
  background-color: rgb(29, 101, 244) !important;
}

._2Jtxm._35Ago ._2kL0S {
  background-color: #548dff !important;
}

.slot_form_container {
  margin-top: 50px;
}

.slot_form_row .input_wrapper {
  border: 1px solid lightgray;
  border-radius: 8px;
  width: 100%;
  background-color: white;
  overflow: hidden;
  height: 62px;
}

.slot_form_row .labeless_input {
  height: 62px;
}

.slot_form_row .input_wrapper input {
  border-bottom: 3px solid white !important;
}

.slot_form_row .input_wrapper input:focus {
  border-bottom: 3px solid #548dff !important;
}

.slot_form_row .blue_theme {
  color: #548dff !important;
}

.css-1u3bzj6-MuiFormControl-root-MuiTextField-root,
.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {
  height: 100% !important;
  width: 100% !important;
  background-color: white;
}

.slot_form_row .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #548dff !important;
  border-width: 2px;
}

.slot_form_row .css-1d3z3hw-MuiOutlinedInput-notchedOutline {
  border: none;
}

.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input:focus {
  height: 100%;
}

._2Jtxm ._1hzhf {
  top: -90%;
}

.add_breaks_btn {
  height: 32px;
  width: 32px;
  border-radius: 7px;
  background-color: #2b6ff8;
  color: white;
}

.add_breaks_btn:hover {
  height: 32px;
  width: 32px;
  border-radius: 7px;
  background-color: #548dff;
  color: white;
}

.delete_breaks_btn {
  height: 32px;
  width: 32px;
  border-radius: 7px;
  background-color: #dc3545;
  color: white;
}

.delete_breaks_btn:hover {
  height: 32px;
  width: 32px;
  border-radius: 7px;
  background-color: #c61e2f;
  color: white;
}

.multistep_container_outer {
  max-height: 93vh;
  overflow: scroll;
  padding-bottom: 100px;
}

.main_multistep_container {
  background-color: white;
  border-radius: 15px;
  border: 1px solid lightgray;
}

.multistep_container_outer::-webkit-scrollbar {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/Assets/components/meetspace/createslot.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,2BAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,2BAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;;EAEI,aAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;EACA,gBAAA;AACJ;;AAEA;EACI,oCAAA;EACA,YAAA;AACJ;;AAEA;EACI,8CAAA;EACA,YAAA;AACJ;;AAEA;EACI,+BAAA;AACJ;;AAEA;EACI,gCAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAEA;EACI,8CAAA;AACJ;;AAEA;EACI,oCAAA;AACJ;;AAGA;EACI,gBAAA;AAAJ;;AAGA;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,yCAAA;AAAJ;;AAGA;EACI,2CAAA;AAAJ;;AAGA;EACI,yBAAA;AAAJ;;AAGA;;EAEI,uBAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,gCAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,SAAA;AAAJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,gBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,uBAAA;EACA,mBAAA;EACA,2BAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ","sourcesContent":[".invite_row {\n    height: 500px;\n}\n\n.one2one_section {\n    border: 1px solid lightgray;\n    border-radius: 14px;\n    background-color: white;\n}\n\n.group_section {\n    border: 1px solid lightgray;\n    border-radius: 10px;\n    background-color: white;\n}\n\n.one2one_section img,\n.group_section img {\n    height: 220px;\n    width: auto;\n}\n\n.invite_container {\n    height: auto;\n    margin-top: 50px;\n}\n\n.invite_row button {\n    background-color: #548dff !important;\n    color: white;\n}\n\n.invite_row button:hover {\n    background-color: rgb(29, 101, 244) !important;\n    color: white;\n}\n\n._3uApM {\n    justify-content: end !important;\n}\n\n._3uApM a {\n    text-decoration: none !important;\n    margin-left: 20px;\n    padding-left: 40px;\n    padding-right: 40px;\n}\n\n._hsN1w {\n    background-color: #548dff !important;\n}\n\n._hsN1w:hover {\n    background-color: rgb(29, 101, 244) !important;\n}\n\n._2Jtxm._35Ago ._2kL0S {\n    background-color: #548dff !important;\n}\n\n// Create Slot Form\n.slot_form_container {\n    margin-top: 50px;\n}\n\n.slot_form_row .input_wrapper {\n    border: 1px solid lightgray;\n    border-radius: 8px;\n    width: 100%;\n    background-color: white;\n    overflow: hidden;\n    height: 62px;\n}\n\n.slot_form_row .labeless_input {\n    height: 62px;\n}\n\n.slot_form_row .input_wrapper input {\n    border-bottom: 3px solid white !important;\n}\n\n.slot_form_row .input_wrapper input:focus {\n    border-bottom: 3px solid #548dff !important;\n}\n\n.slot_form_row .blue_theme {\n    color: #548dff !important;\n}\n\n.css-1u3bzj6-MuiFormControl-root-MuiTextField-root,\n.css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root {\n    height: 100% !important;\n    width: 100% !important;\n    background-color: white;\n}\n\n.slot_form_row .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border-color: #548dff !important;\n    border-width: 2px\n}\n\n.slot_form_row .css-1d3z3hw-MuiOutlinedInput-notchedOutline {\n    border: none;\n}\n\n.css-nxo287-MuiInputBase-input-MuiOutlinedInput-input:focus {\n    height: 100%;\n}\n\n._2Jtxm ._1hzhf {\n    top: -90%;\n}\n\n.add_breaks_btn {\n    height: 32px;\n    width: 32px;\n    border-radius: 7px;\n    background-color: #2b6ff8;\n    color: white;\n}\n\n.add_breaks_btn:hover {\n    height: 32px;\n    width: 32px;\n    border-radius: 7px;\n    background-color: #548dff;\n    color: white;\n}\n\n.delete_breaks_btn {\n    height: 32px;\n    width: 32px;\n    border-radius: 7px;\n    background-color: #dc3545;\n    color: white;\n}\n\n.delete_breaks_btn:hover {\n    height: 32px;\n    width: 32px;\n    border-radius: 7px;\n    background-color: #c61e2f;\n    color: white;\n}\n\n.multistep_container_outer{\n    max-height: 93vh;\n    overflow: scroll;\n    padding-bottom: 100px;\n}\n\n.main_multistep_container {\n    background-color: white;\n    border-radius: 15px;\n    border: 1px solid lightgray;\n}\n\n.multistep_container_outer::-webkit-scrollbar {\n    display: none;\n}\n\n// ._3uApM{\n//     display: none !important;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
